export function stripHTML(html?: string): string {
  if (!html) {
    return '';
  }
  return html.replace(/(<([^>]+)>)|(&[^;]+;)/gi, '');
}
